<div class="d-flex m-auto sublayerContainer">
    <!-- string -->
    <div class="p-0 form-check form-check-inline" *ngIf="subLayerIsString(subLayer)">
        <input class="form-check-input" type="checkbox" [(ngModel)]="checkedSubLayers[subLayer]"
            (change)="subLayerSelected()">
        <label class="form-check-label">{{subLayer}}</label>
    </div>
    <!-- object -->
    <div *ngIf="!subLayerIsString(subLayer)" class="w-100"><!-- TODO: Remove function call from template -->
        <div class="d-flex">
            <div class="p-0 form-check form-check-inline">
                <input class="form-check-input" type="checkbox" [(ngModel)]="checkedSubLayers[subLayer.Name]"
                    name="sublayerWithoutNestedSublayers"
                    (change)="subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])"
                    [attr.id]="'hs-sublayers-' + subLayer.Name + '-' + app " *ngIf="!subLayer.Layer">
                <input class="form-check-input" type="checkbox" [(ngModel)]="withChildren[subLayer.Name]"
                    name="sublayerWithNestedSublayers"
                    (change)="subLayerSelected(subLayer, withChildren[subLayer.Name])"
                    [attr.id]="'hs-sublayers-' + subLayer.Name + '-' + app " *ngIf="subLayer.Layer">

                <div class="p-0 d-inline-flex flex-grow" *ngIf="subLayer.Layer">
                    <label class="form-check-label m-0"
                        [ngClass]="{'hs-checkmark':withChildren[subLayer.Name],'hs-uncheckmark':!withChildren[subLayer.Name]}"
                        [attr.for]="'hs-sublayers-' + subLayer.Name + '-' + app "></label>
                    <div (click)="toggleExpanded()" style="cursor:pointer"
                        [ngClass]="{'grayed': HsLayerManagerService.currentResolution >= subLayer.maxResolution}">
                        {{subLayer.Title || subLayer.Name}}
                        <button type="button" class="btn btn-sm p-0" style="font-size: 0.6rem;">
                            <i [ngClass]="{'icon-chevron-down': expanded, 'icon-chevron-right': !expanded}"></i>
                        </button>
                    </div>
                </div>
                <div *ngIf="!subLayer.Layer">
                    <label class="form-check-label m-0"
                        [ngClass]="{'hs-checkmark':checkedSubLayers[subLayer.Name],'hs-uncheckmark':!checkedSubLayers[subLayer.Name], 'grayed': (HsLayerManagerService.currentResolution > subLayer.maxResolution) }"
                        [attr.for]="'hs-sublayers-' + subLayer.Name + '-' + app ">{{subLayer.Title ||
                        subLayer.Name}}</label>
                </div>
            </div>
        </div>
        <div *ngIf="subLayer.Layer" class="ms-4" [hidden]="!expanded">
            <div *ngFor="let subLayer of subLayer.Layer">
                <div *ngIf="subLayerIsString(subLayer)">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="checkedSubLayers[subLayer]"
                        (change)="subLayerSelected(subLayer,checkedSubLayers[subLayer.Name])"
                        [attr.id]="'hs-sublayers-'+subLayer" [ngModelOptions]="{standalone: true}">
                    <label class="form-check-label" [attr.for]="'hs-sublayers-'+subLayer">{{subLayer}}</label>
                </div>
                <hs-layer-editor-sub-layer-checkbox [subLayer]="subLayer"
                    *ngIf="!subLayerIsString(subLayer)"><!-- TODO: Remove function call from template -->
                </hs-layer-editor-sub-layer-checkbox>
            </div>
        </div>

    </div>
</div>